import script from "./ItemsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ItemsPage.vue?vue&type=script&lang=ts&setup=true"

import "./ItemsPage.vue?vue&type=style&index=0&id=95fa2c34&lang=sass&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95fa2c34"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSeparator,QList});
